module.exports = __webpack_public_path__ + "img/r6.2e8c4de1.jpg";